import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Button, Collapse } from 'reactstrap';
import moment from 'moment';

import { jobDetailsForm } from '../../constants/FormConstants';
import jobStandardIds from '../../constants/JobStandardIds';
import { isCompleted } from '../../util/JobStateHelper';
import { getPlasticWrapStatusTitle } from '../../util/PlasticWrapStatusHelper';
import {
  isImportJobType,
  isImportAndHeatTreatment,
  isExportJobType,
  isExportAndLogs,
  isExportOther,
  isImportAndContainer,
  isExportAndContainer,
  isBreakBulkJobType,
  isExportOtherMBApples,
  isImportOrExportAndContainer,
} from '../../util/JobTypeHelper';
import { isGasFree, isMethylBromide,isHydrogenCyanide,isAlPVessel, isVaporPhos } from '../../util/TreatmentTypeHelper';

import PlainTextField from '../fields/PlainTextField';
import PlainTextDateField from '../fields/PlainTextDateField';
import { Band, ToggleButton } from '../layout';
import { useNavigate } from 'react-router-dom';

const JobDetailsSummary = ({
  id,
  currentState,
  history,
  privateClient,
  stopCredit,
  type,
  containerType,
  category,
  area,
  technician,
  location,
  vessel,
  voyage,
  standard,
  sizeOfContainer,
  treatmentType,
  invoiceNumber,
  treatmentTypeDetails,
  treatmentDetails,
  estimatedTimeOfArrival,
  dateOfRequest,
  importShipmentDetails,
  exportShipmentDetails,
  canEditJob,
  parentJobReference,
  clientDetails,
  splitCost,
  travelZone,
  doNotCertify,
  docketNumber
}) => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(!isCompleted(currentState));

  const toggleSeeMore = () => setCollapsed(!collapsed);

  const editJob = () => navigate('/jobs/details/edit/' + id);// history.push('/jobs/details/edit/' + id);

  const isDaffId = () => standard && [jobStandardIds.DaffId, jobStandardIds.DaffArhopalusId].includes(standard.id);

  const showClientTypeBorder = () => privateClient || stopCredit;

  const {
    destination,
    markings,
    numberOfContainers,
    commodity,
    disclaimerReceived,
    freshProduce,
    jobDescription,
    covered,
    movement,

  } = treatmentTypeDetails || {};

  const {
    treatmentTypeId,
    comments,
    dosageRate,
    mandatoryMinimumTemperature,
    treatmentPeriod,
    expectedQuantity,
    expectedVentilationDate,
    plasticWrapStatus,
    endPointReadingPercentage,
    dateIntendedTreatment,
    gasAssessment,
    residueRelocation,
    residueRemoval,
    disposalResidue,
    quenchingResidue,
    chamberMonitoring,
    callOutFee,
    removalDisposalPipeFan,
    mainDosageRate,
      monitoringType,
      applicationType,
  } = treatmentDetails || {};
  const jas = treatmentType.jas;
  const packVolume = treatmentType.packVolume;
  var {doseToConcentration} = treatmentDetails ||{}
  const { bookingReference, vbCode, cargoLocation, orderNumber, _BillOfLading, bacc, tpin } =
    exportShipmentDetails || importShipmentDetails || {};

  const isContainer = isImportAndContainer(type) || isExportAndContainer(type);
  let status =clientDetails? clientDetails.status ?clientDetails.status : 'Active':'Active'
  //console.log("tDets",treatmentDetails)
  //doseToConcentration =   isHydrogenCyanide(treatmentTypeId) && doseToConcentration?true:doseToConcentration?doseToConcentration:false;

  return (
    <Band>
        <div className="form-section">
          <Container>
            <Row>
              <Col xs="8">
                <h4>Job Details</h4>
              </Col>
              <Col xs="4" className="text-right">
                {canEditJob && status === 'Active' ? (
                  <ToggleButton
                    color="light"
                    onClick={editJob}
                    ligature="mode_edit"
                  />
                ) : null}
              </Col>
              <Col xs="12">
                <Row>
                  <Col
                    xs="4"
                    className={privateClient ? 'clienttype-checked' : ''}
                  >
                    <PlainTextField
                      name="privateClient"
                      label="Private Client"
                      value={privateClient ? 'Yes' : 'No'}
                    />
                  </Col>
                  <Col
                    xs="4"
                    className={stopCredit ? 'clienttype-checked' : ''}
                  >
                    <PlainTextField
                      name="stopCredit"
                      label="Stop Credit"
                      value={stopCredit ? 'Yes' : 'No'}
                    />
                  </Col>
                  <Col
                    xs="4"
                    className={doNotCertify ? 'clienttype-checked' : ''}
                  >
                    <PlainTextField
                      name="doNotCertify"
                      label="Do Not Certify"
                      value={doNotCertify ? 'Yes' : 'No'}
                    />
                  </Col>
                </Row>
              </Col>
              {!isHydrogenCyanide(treatmentTypeId)?
              <Col
                    xs="4"
                    className={doseToConcentration ? 'clienttype-checked' : ''}
                  >
                    <PlainTextField
                      name="doseToConcentration"
                      label="Dose To Volume"
                      value={doseToConcentration ? 'Yes' : 'No'}
                    />
                  </Col>
                  :null}
              <Col xs="8">
                <PlainTextField
                  name="location"
                  label="Location"
                  value={location}
                />
              </Col>
              <Col xs="4">
                <PlainTextField
                  name="parentJobReference"
                  label="Parent Job #"
                  value={parentJobReference}
                />
              </Col>
              <Col xs="6" lg="4">
                <PlainTextField name="vessel" label="Vessel" value={vessel} />
              </Col>
              <Col xs="6" lg="4">
                <PlainTextField name="voyage" label="Voyage" value={voyage} />
              </Col>
              <Col xs="6" lg="4">
                <PlainTextField
                  name="destination"
                  label="Destination"
                  value={destination}
                />
              </Col>
              <Col xs="6" lg="4">
                <PlainTextField
                  name="treatmentType"
                  label="Treatment Type"
                  value={treatmentType && treatmentType.displayName}
                />
              </Col>
              {mainDosageRate!=undefined || mainDosageRate != ''?
              <Col xs="6" lg="4">
                <PlainTextField
                  name="mainDosageRate"
                  label="EF Main Dosage Rate"
                  value={mainDosageRate}
                />
              </Col> :null}
              <Col xs="6" lg="4">
                <PlainTextField
                  name="dosageRate"
                   label={mainDosageRate? 'EF CO2 Dosage':"Dosage Rate"}
                  value={dosageRate}
                />
              </Col>
              <Col xs="6" lg="4">
                <PlainTextField
                  name="standard"
                  label="Standard"
                  value={standard && standard.displayName}
                />
              </Col>
              {isDaffId(standard, jobStandardIds) ? (
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="plasticWrapStatus"
                    label="Plastic Wrap Status"
                    value={getPlasticWrapStatusTitle(plasticWrapStatus)}
                  />
                </Col>
              ) : null}
              <Col xs="6" lg="4">
                <PlainTextField
                  name="mandatoryMinimumTemperature"
                  label="Mandatory Minimum Temperature"
                  value={mandatoryMinimumTemperature}
                />
              </Col>
              <Col xs="6" lg="4">
                <PlainTextField
                  name="treatmentPeriod"
                  label="Treatment Period"
                  value={treatmentPeriod}
                />
              </Col>
                {isBreakBulkJobType(type) ? (
                  <Col xs="6" lg="4">
                    <PlainTextField
                      name="jas"
                      label="Declared Vol M3"
                      value={jas}
                    />
                  </Col>
                ) : null}
                   {isBreakBulkJobType(type) ? (
                  <Col xs="6" lg="4">
                    <PlainTextField
                      name="packVolume"
                      label="Pack Vol M3"
                      value={packVolume}
                    />
                  </Col>
                ) : null}

              {isMethylBromide(treatmentTypeId) ? (
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="endPointReadingPercentage"
                    label="End Point Reading"
                    value={
                      endPointReadingPercentage
                        ? `${endPointReadingPercentage}%`
                        : null
                    }
                  />
                </Col>
              ) : null}
              <Col xs="8">
                <PlainTextField
                  name="Date of Intended Treatment"
                  label="Date of Intended Treatment"
                  value={dateIntendedTreatment? moment(dateIntendedTreatment).format('DD/MM/YYYY HH:mm',
                  ):null}
                />
              </Col>
              <Col xs="4" className={covered ? 'clienttype-checked' : ''}>
                <PlainTextField
                  name="Covered"
                  label="covered"
                  value={covered ? 'Yes' : 'No'}
                />
              </Col>



              {isExportAndLogs(type) ? (
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="expectedQuantity"
                    label="Expected Quantity (mb/kg)"
                    value={expectedQuantity}
                  />
                </Col>
              ) : null}
              {isExportAndLogs(type) ? (
                <Col xs="6" lg="4">
                  <PlainTextDateField
                    name="expectedVentilationDate"
                    label="Expected Ventilation Date"
                    value={expectedVentilationDate}
                  />
                </Col>
              ) : null}

              <Col xs="12" lg="12">
                <PlainTextField
                  name="markings"
                  label={isContainer?"Markings and Seal numbers":"Markings"}
                  value={
                    markings
                      ? markings
                          .map((marking) =>
                            isContainer
                              ? `${marking.containerNumber}${
                                  marking.sealNumber
                                    ? ` ${marking.sealNumber}`
                                    : ''
                                }`
                              : marking.markingNumber,
                          )
                          .join(', ')
                      : ''
                  }
                />
              </Col>
            
              <Col xs="12" lg="12">
                <PlainTextField
                  name="comments"
                  label="Comments"
                  value={comments}
                />
              </Col>
            </Row>
             { isAlPVessel(treatmentTypeId) || isVaporPhos(treatmentTypeId)?
             <Row>
              <Col xs="2" lg="5" style={{ color: 'red' }}>
                <PlainTextField
                  name="applicationType"
                  label="Application Type"
                  value={applicationType}
                />
                </Col>
                <Col xs="2" lg="5" style={{ color: 'red',whiteSpace:'nowrap' }}>
                <PlainTextField
                  name="monitoringType"
                  label="Monitoring Type"
                  value={monitoringType}
                />
              </Col> </Row>:null}
            <Collapse isOpen={!collapsed} className="mt-3">
              <Row>
                <Col xs="6" lg="4">
                  <PlainTextDateField
                    name="estimatedTimeOfArrival"
                    label="ETA"
                    value={estimatedTimeOfArrival}
                  />
                </Col>
                <Col xs="6" lg="4">
                  <PlainTextDateField
                    name="dateOfRequest"
                    label="Date of Request"
                    value={dateOfRequest}
                  />
                </Col>
                {isImportJobType(type) ? (
                  <Col xs="6" lg="4">
                    <PlainTextField
                      name="billOfLading"
                      label="Bill of Lading"
                      value={_BillOfLading}
                    />
                  </Col>
                ) : null}
                {isImportJobType(type) ? (
                  <Col xs="6" lg="4">
                    <PlainTextField name="bacc" label="BACC #" value={bacc} />
                  </Col>
                ) : null}
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="orderNumber"
                    label="Order #"
                    value={orderNumber}
                  />
                </Col>
                {isImportAndHeatTreatment(type) ? (
                  <Col xs="6" lg="4">
                    <PlainTextField name="tpin" label="TPIN" value={tpin} />
                  </Col>
                ) : null}
                {isExportJobType(type) ? (
                  <Col xs="6" lg="4">
                    <PlainTextField
                      name="bookingReference"
                      label="Booking Reference"
                      value={bookingReference}
                    />
                  </Col>
                ) : null}
                {isExportAndLogs(type) ? (
                  <Col xs="6" lg="4">
                    <PlainTextField
                      name="vbCode"
                      label="VB Code/Link"
                      value={vbCode}
                    />
                  </Col>
                ) : null}
                {isExportAndLogs(type) ? (
                  <Col xs="6" lg="4">
                    <PlainTextField
                      name="cargoLocation"
                      label="Cargo Location"
                      value={cargoLocation}
                    />
                  </Col>
                ) : null}
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="containerType"
                    label="Container Type"
                    value={containerType && containerType.displayName}
                  />
                </Col>
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="category"
                    label="Category"
                    value={category && category.displayName}
                  />
                </Col>
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="sizeOfContainer"
                    label="Size of Container"
                    value={sizeOfContainer && sizeOfContainer.displayName}
                  />
                </Col>
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="numberOfContainers"
                    label={standard&& isExportOtherMBApples(type,treatmentTypeId,commodity,standard.id)?"Number of Chambers":"Number of Containers"}
                    value={numberOfContainers}
                  />
                </Col>
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="area"
                    label="Area"
                    value={area && area.displayName}
                  />
                </Col>
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="commodity"
                    label="Commodity"
                    value={commodity}
                  />
                </Col>
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="disclaimerReceived"
                    label="Disclaimer Received"
                    value={disclaimerReceived ? 'Yes' : 'No'}
                  />
                </Col>
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="freshProduce"
                    label="Fresh Produce"
                    value={freshProduce ? 'Yes' : 'No'}
                  />
                </Col>
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="technician"
                    label="Technician"
                    value={technician && technician.name}
                  />
                </Col>
                <Col xs="6" lg="4">
                  <PlainTextField
                    name="invoiceNumber"
                    label="Invoice #"
                    value={invoiceNumber}
                  />
                </Col>
                 <Col xs="6" lg="4">
                  <PlainTextField
                    name="docketNumber"
                    label="Docket #"
                    value={docketNumber}
                  />
                </Col>
               
                <Col lg="12">
                  <PlainTextField
                    name="jobDescription"
                    label="Job Description"
                    value={jobDescription}
                  />
                </Col>
              </Row>
              {isGasFree(treatmentTypeId)?
                <Col>
                <PlainTextField
                name="treatmentDetails.gasAssessment"
                label="Gas Assessment"
                value={gasAssessment ? 'Yes' : 'No'}
              />
              <PlainTextField
                name="treatmentDetails.residueRelocation"
                label="Residue Relocation"
                value={residueRelocation ? 'Yes' : 'No'}
              />
                <PlainTextField
                name="treatmentDetails.residueRemoval"
                label="Residue Removal"
                value={residueRemoval ? 'Yes' : 'No'}
              />
                <PlainTextField
                name="treatmentDetails.disposalResidue"
                label="Disposal of Residue"
                value={disposalResidue ? 'Yes' : 'No'}
              />
                <PlainTextField
                name="treatmentDetails.quenchingResidue"
                label="Quenching Residue"
                value={quenchingResidue ? 'Yes' : 'No'}
              />
                <PlainTextField
                name="treatmentDetails.chamberMonitoring"
                label="Chamber Monitoring"
                value={chamberMonitoring ? 'Yes' : 'No'}
              />
                <PlainTextField
                name="treatmentDetails.callOutFee"
                label="Call Out Fee"
                value={callOutFee ? 'Yes' : 'No'}
              />
               <PlainTextField
                name="treatmentDetails.removalDisposalPipeFan"
                label="Removal & Disposal of Used Piping & or Fans"
                value={removalDisposalPipeFan ? 'Yes' : 'No'}
              />

                
            </Col>:null}
            <PlainTextField
                name="splitCost "
                label="Split Cost"
                value={splitCost?'Yes':'No'}
              />
               <PlainTextField
                name="travelZone "
                label="Travel Zone"
                value={travelZone}
              />
            </Collapse>
            <Button color="light" className="mt-3" onClick={toggleSeeMore}>
              {collapsed ? 'See More' : 'See Less'}
              {
                <i className="material-icons ml-1">
                  {collapsed ? 'expand_more' : 'expand_less'}
                </i>
              }
            </Button>
          </Container>
        </div>
      </Band>
    );
  }



JobDetailsSummary.propTypes = {
  id: PropTypes.string,
  currentState: PropTypes.string,
  history: PropTypes.object.isRequired,
  privateClient: PropTypes.bool,
  stopCredit: PropTypes.bool,
  type: PropTypes.object,
  containerType: PropTypes.object,
  category: PropTypes.object,
  area: PropTypes.object,
  technician: PropTypes.object,
  location: PropTypes.string,
  vessel: PropTypes.string,
  voyage: PropTypes.string,
  standard: PropTypes.object,
  sizeOfContainer: PropTypes.object,
  treatmentType: PropTypes.object,
  invoiceNumber: PropTypes.string,
  treatmentTypeDetails: PropTypes.object,
  treatmentDetails: PropTypes.object,
  estimatedTimeOfArrival: PropTypes.string,
  dateOfRequest: PropTypes.string,
  importShipmentDetails: PropTypes.object,
  exportShipmentDetails: PropTypes.object,
  canEditJob: PropTypes.bool,
  parentJobReference: PropTypes.any,
  clientDetails: PropTypes.object,
  splitCost: PropTypes.bool,
  travelZone: PropTypes.string,
};

export default JobDetailsSummary;
